<template>
  <div class="bg-gray-900">
    <div class="container mx-auto px-4 py-20">
      <div class="max-w-6xl mx-auto">
        <h2 class="text-3xl md:text-4xl font-bold text-white text-center mb-4">
          Join the Academic Alerts
        </h2>
        <p class="text-gray-100 text-center max-w-2xl mx-auto mb-12">
          Connect with scholars worldwide, share knowledge, and stay updated
          with the latest academic events and buzz.
        </p>

        <div class="grid md:grid-cols-3 gap-8">
          <div
            v-for="cta in ctas"
            :key="cta.title"
            class="group bg-white p-8 rounded-2xl text-center border border-gray-100 hover:border-primary/20 shadow-lg shadow-black/5 hover:shadow-xl transition-all duration-300"
          >
            <div class="relative">
              <div
                class="absolute inset-0 bg-primary/5 rounded-full blur-2xl transform group-hover:scale-110 transition-transform"
              ></div>
              <Icon
                :name="cta.icon"
                class="w-10 h-10 text-primary/80 relative mx-auto mb-6 transform group-hover:scale-110 transition-transform"
              />
            </div>
            <h3 class="text-xl font-semibold text-gray-900 mb-3">
              {{ cta.title }}
            </h3>
            <p class="text-gray-600 mb-6 text-sm leading-relaxed">
              {{ cta.description }}
            </p>
            <nuxt-link
              :to="cta.link"
              class="inline-flex items-center px-6 py-2.5 text-sm font-medium bg-gray-900 text-white rounded-lg hover:bg-gray-800 transform hover:-translate-y-0.5 transition-all duration-200"
            >
              <Icon :name="cta.buttonIcon" class="w-4 h-4 mr-2" />
              {{ cta.buttonText }}
            </nuxt-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const ctas = [
  {
    title: "Submit Event",
    description: "Share your academic events and reach scholars worldwide.",
    icon: "heroicons:calendar-days",
    buttonIcon: "heroicons:plus-circle",
    buttonText: "Add Event",
    link: "/add",
  },
  {
    title: "Become a Member",
    description: "Join our network and unlock exclusive academic benefits.",
    icon: "heroicons:user-group",
    buttonIcon: "heroicons:user-plus",
    buttonText: "Join Now",
    link: "/become-a-member",
  },
  {
    title: "Explore Events",
    description: "Find academic events tailored to your interests.",
    icon: "heroicons:magnifying-glass",
    buttonIcon: "heroicons:arrow-right",
    buttonText: "Browse All",
    link: "/explore",
  },
];
</script>
